import type { MedicineCategory, StockLogType } from '@/api/types';

export interface CreateMedicineRequest {
  name: string;
  shortName?: string;
  genericName?: string;
  composition?: string;
  category: MedicineCategory;
  stock: number;
  minStock: number;
  unit: string;
  expiryDate: string;
  supplierId: string;
  costPrice: number;
  price: number;
  batchNo: string;
  location?: string;
  gstRate: number;
  barcode?: string;
}

/** Every field optional — only what changed is sent, matching the server's null-means-unchanged contract. */
export type UpdateMedicineRequest = Partial<CreateMedicineRequest> & { stock?: number };

export interface AdjustStockRequest {
  stock: number;
  type: StockLogType;
  note?: string;
}

export interface RestockRequest {
  quantity: number;
  batchNo?: string;
  expiryDate?: string;
  costPrice?: number;
  note?: string;
}

export interface CreateSupplierRequest {
  name: string;
  contact: string;
  email?: string;
  address?: string;
}

export type UpdateSupplierRequest = Partial<CreateSupplierRequest>;

export const MEDICINE_CATEGORIES: MedicineCategory[] = [
  'Analgesic',
  'Antibiotic',
  'Antidiabetic',
  'Cardiac',
  'Antihistamine',
  'Antacid',
  'Vitamin',
  'Antifungal',
  'Antihypertensive',
  'Antidepressant',
  'Other',
];

export const MEDICINE_UNITS = [
  'Tablets',
  'Capsules',
  'Syrup',
  'Injection',
  'Cream',
  'Drops',
  'Powder',
  'Sachet',
  'Inhaler',
  'Patch',
];

/** 12% is the most common rate for medicines in India. */
export const GST_RATES = [0, 5, 12, 18, 28];
